const messages = {
  title: "Mediapakketten",
  title_media: "Mediapakketten",
  description:
    "Hier vindt u een breed scala aan productdocumentatie en media van onze merken Bridgestone en Firestone, evenals andere bandenoplossingen. Maak gebruik van de verschillende filteropties of voer gerichte zoekopdrachten in het zoekveld in om snel te vinden wat u zoekt.",
  short_description:
    "Productbrochures, prijslijsten, Pricat-bestanden, logo’s, content voor sociale media, instore-tv en meer.",
  mediaCategories: {
    products: "Producten",
    brand_and_solutions: "Merk & oplossingen",
    season_and_promotions: "Seizoen & promoties",
    format: "Formaat",
    cars_and_vans: "Personenauto, SUV, bedrijfswagen",
    truck_and_buses: "Vrachtwagen & bus",
    motorcycle: "Motorfiets",
    agriculture: "Landbouw",
    construction_machinery: "Bouwmachines",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialen",
    brochures: "Productbrochures",
    price_list: "Prijslijsten",
    materials: "Materialen",
    video_in_store: "Video met ondertitels",
    video_online: "Video zonder ondertitels",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Social media",
    logos: "Logo's",
    summer: "Zomer",
    winter: "Winter",
    all_season: "Alle seizoenen",
    promotions: "Acties",
    price: "Pricat",
    b_drive: "B-drive",
    media_library: "Producten & Media",
    media_packages: "Mediapakketten",
    season: "Seizoen",
    trucks: "Vrachtwagens",
    technology: "Technologie",
    oe: "OE",
  },
  mediasPage: {
    title: "Producten & Media",
    description:
      "Welkom bij het mediagedeelte over Bridgestone- en Firestone-producten. Hier vindt u actuele productafbeeldingen, logo's en talrijke banners, video's en digitale sjablonen die u bijvoorbeeld kunt gebruiken op uw website of op sociale media.",
    bDrive: {
      title: "Product afbeeldingen & logo's",
      description:
        "Download via B-drive alle goedgekeurde logo's en afbeeldingen van Bridgestone en Firestone producten.",
    },
  },
  buttons: {
    media: "NAAR Mediapakketten",
  },
  searchMedia: "Voer zoekwoord in",
  searchResults: "Zoekresultaten",
};

export default {
  messages,
};
